<script>
  export let source;
  export let height;
  import { onMount } from "svelte";

  let el;

  /*onMount(() => {
    let iframeDoc = el.contentDocument
      ? el.contentDocument
      : el.contentWindow.document;

    let body = iframeDoc.body,
      html = iframeDoc.documentElement;

    let height = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    let iframeHeight = el.contentDocument.body.scrollHeight + "px";

    el.style.setProperty("--height", height + "px");
  });*/
</script>

<div class="locked-embed" />
<iframe
  title="Locked Embed"
  class="locked-embed-iframe"
  src={source}
  frameborder="0"
  marginheight="0"
  marginwidth="0"
  {height}
  bind:this={el}
/>

<style>
  .locked-embed-iframe {
    width: 100%;
    /*height: var(--height);*/
  }
</style>
